import { apiSlice } from "../../app/api/apiSlice";
import { generateFormatedURL } from "../urlFormatter";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => {
    return ({
      resetPassword: builder.mutation({
        query: (credentials) => ({
          url: '/Account/reset-password',
          method: 'POST',
          responseHandler: 'text',
          //body: { ...credentials }
          body: {
            email: credentials.email,
            password: credentials.password,
            token: credentials.token,
          }
          //body:  JSON.stringify(credentials) 
        })
      }),

      forgotPassword: builder.mutation({
        query: (credentials) => ({
          url: `Account/forgot-password/${credentials?.email}`,
          method: 'POST',
          responseHandler: 'text',
        })
      }),

      login: builder.mutation({
        query: (credentials) => ({
          url: '/Account/login',
          method: 'POST',
          responseHandler: 'text',
          //body: { ...credentials }
          body: {
            email: credentials.email,
            password: credentials.password,
          }
          //body:  JSON.stringify(credentials) 
        })
      }),

      refreshToken: builder.mutation({
        query: (refreshToken) => ({
          url: `/Account/refresh-token`,
          method: 'POST',
          responseHandler: 'text',
          body: {
            token: refreshToken,
          }
        })
      }),

      register: builder.mutation({
        query: (credentials) => ({
          url: 'Account/register',
          method: 'POST',
          responseHandler: 'text',
          body: credentials
        })
      }),

      changePassword: builder.mutation({
        query: (credentials) => ({
          url: 'Account/change-password',
          method: 'POST',
          responseHandler: 'text',
          body: {
            // email: credentials?.email,
            currentPassword: credentials.currentPassword,
            newPassword: credentials.newPassword
          }
        })
      }),
      getUserDropdownList: builder.query<any, void>({
        query: () => "Account/dropdownList"
      }),
      getUserListing: builder.query({
        query: (args) => "/Account".concat(generateFormatedURL(args)),
      }),
      getUserDetail: builder.query({
        query: (id) => `/Account/${id}`,
      }),
      getRegisterRoleDropDownList: builder.query({
        query: () => "/Account/register-role/dropdownlist",
      }),
      getRoleDropDownList: builder.query({
        query: () => "/role/dropdownlist",
      }),
      createUser: builder.mutation({
        query: (credentials) => ({
          url: 'Account',
          method: 'POST',
          body: credentials
        })
      }),
      updateUser: builder.mutation({
        query: (credentials) => ({
          url: 'Account',
          method: 'PUT',
          body: credentials
        })
      }),
      getUserRegistrationRequestListing: builder.query({
        query: (args) => "/Account/registration-request".concat(generateFormatedURL(args)),
      }),
      getUserRegistrationRequestDetail: builder.query({
        query: (userRegistrationRequestId) => `/Account/registration-request/${userRegistrationRequestId}`,
      }),
      approveRegistration: builder.mutation({
        query: (credentials) => ({
          url: 'Account/registration-request/approve',
          method: 'POST',
          body: credentials
        })
      }),
      declineRegistration: builder.mutation({
        query: (id) => ({
          url: `Account/registration-request/${id}/decline`,
          method: 'POST',
        })
      }),
    });
  },
});

export const {
  useResetPasswordMutation,
  useForgotPasswordMutation,
  useLoginMutation,
  useRefreshTokenMutation,
  useRegisterMutation,
  useChangePasswordMutation,
  useLazyGetUserDropdownListQuery,
  useLazyGetUserListingQuery,
  useLazyGetUserDetailQuery,
  useLazyGetRegisterRoleDropDownListQuery,
  useLazyGetRoleDropDownListQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useLazyGetUserRegistrationRequestListingQuery,
  useLazyGetUserRegistrationRequestDetailQuery,
  useApproveRegistrationMutation,
  useDeclineRegistrationMutation,
} = authApiSlice;